// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type ServerSummary = {};

export type ServerPostPayload = {
  server: {
    authentication: {
      password: string,
      ssh_keys?: Array<string>,
      username?: string,
    },
    cores: number,
    hostname: string,
    image: string,
    ips: Array<{
      fake?: boolean,
      version: 4 | 6,
    }>,
    location: string,
    memory: number,
    volumes: Array<{
      size: number,
    }>,
  },
};

export type State = {
  list: ListState<ServerSummary>,
};

type ServersResourceType = SequoiaResourceType<{
  fetchResource: ServerSummary,
  postPayload: ServerPostPayload,
}>;

export type ServersResource = SequoiaResource<ServersResourceType>;

export const serversResource: ServersResource = createSequoiaResource(
  'cloud',
  'servers',
  {
    fetchPath: 'hosting/servers',
    postPath: 'hosting/from-templates',
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...serversResource.listReducer,
});
